<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import { Icon, Spinner } from "sveltestrap";

    export let isSaving = false;
    export let text = 'Guardar';

    const dispatch = createEventDispatcher();

    function onClick(): void {
        
        if (isSaving) {
            return;
        }
        dispatch('save');
    }

</script>

<button class="btn btn-success" type="button" on:click={onClick} disabled={isSaving}>
    {#if isSaving}
        <Spinner size="sm" /> Guardando
    {:else}
        <Icon name="upload" /> {text}
    {/if}
</button>
